import { default as React } from 'react';
import {Divider, Grid, makeStyles} from '@material-ui/core';
import {CheckboxInputGrid, MappingState} from 'Quoting/components/shared/CheckboxInputGrid';
import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {getBenefitArrayPaths, getParentSchedulePath} from '../Common/PropertyPaths';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import { FormRowGrid, GridRowProps } from 'Quoting/components/shared/GridRow';
import { QuoteFormElement } from 'Quoting/components/shared/QuoteFormElement';
import { FormWrapper } from 'Quoting/components/shared/QuoteFormWrapper';

const useSectionLabelStyles = makeStyles(() => ({
  divider: {
    width: '100%',
    margin: '0.25rem 0',
  },
}));

const ChildhoodBenefitsErrorKey = 'CIChildhoodConditions.childhoodConditionsPct';

const coverageIndex = 0;
const benefitName = 'childhoodConditionsDetails';

export const ChildhoodBenefitsBlock = () => {
  const classes = useSectionLabelStyles();
  const {getBenefitLabelMapping, getQuoteFieldValue, updateQuoteFieldValue} = useQuoteField();
  const {selectedPlan} = useSelector((state: ReducerState) => state.quoteForm);

  const paths: MappingState[] = getBenefitLabelMapping(
    benefitName,
    `${getParentSchedulePath(selectedPlan?.planIndex, coverageIndex)}.${benefitName}`
  );
  const {quoteFormErrors} = useSelector((state: ReducerState) => state.quoteForm);
  const {BR_QuotingTool_EIS_Validation} = useSelector((state: ReducerState) => state.featureFlag);

  const childhoodBenefits = getBenefitArrayPaths(selectedPlan?.planIndex, coverageIndex, benefitName);
 
  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'childhood-benefits-row-1'},
      items: [
        {
          key: 'childhood-benefits',
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Childhood Conditions (100%)"
              type="number"
              value={getQuoteFieldValue<number>(childhoodBenefits.childhoodConditionsPct)}
              id={childhoodBenefits.childhoodConditionsPct}
              onChange={e =>
                updateQuoteFieldValue(childhoodBenefits.childhoodConditionsPct, Number(e.target.value) / 100)
              }
              error={BR_QuotingTool_EIS_Validation ? Boolean(quoteFormErrors?.[ChildhoodBenefitsErrorKey]) : undefined}
              helperText={quoteFormErrors ? quoteFormErrors[ChildhoodBenefitsErrorKey] : undefined}
              adornment="percentage"
              disabled
            />
          ),
          props: {xs: 6, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'childhood-benefits-row-2'},
      items: [
        {
          key: 'childhood-benefit-options',
          element: <CheckboxInputGrid state={paths} gridLength={3} />,
          props: {xs: 12, sm: 12, md: 12},
        },
      ],
    },
    {
      rowProps: {key: 'childhood-benefits-row-5'},
      items: [
        {
          key: 'childhood-benefits-divider',
          element: <Divider className={classes.divider} />,
          props: {xs: 12, sm: 12, md: 12},
        },
      ],
    },
    {
      rowProps: {key: 'childhood-benefits-row-6'},
      items: [
        {
          key: 'neonatal-intensive-care',
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Neonatal Intensive Care Unit (100%)"
              type="number"
              value={getQuoteFieldValue<number>(childhoodBenefits.neonatalICUPct)}
              id={childhoodBenefits.neonatalICUPct}
              onChange={e => updateQuoteFieldValue(childhoodBenefits.neonatalICUPct, Number(e.target.value) / 100)}
              adornment="percentage"
              disabled
            />
          ),
          props: {xs: 6, sm: 6, md: 6},
        },
      ],
    },
  ];

  return (
    <FormWrapper title="Childhood Benefits (% of Child Benefit)" collapsible withSeparator expanded>
      <Grid container alignItems="center">
        <FormRowGrid rows={rows} />
      </Grid>
    </FormWrapper>
  );
};
